import type { CockpitPrincipal } from '@/auth/AuthProvider';
import { cockpitVersion } from '@/version';

export const FEEDBACK_URL =
  (import.meta.env.VITE_FFS_FEEDBACK_URL as string | undefined)?.trim() ||
  'https://kraken.fusionflow.dev:7788/feedback';
export const FEEDBACK_BACKEND_URL =
  (import.meta.env.VITE_FFS_BACKEND_URL as string | undefined)?.trim() ||
  'https://kraken.fusionflow.dev:7788';
export const FEEDBACK_ENVIRONMENT =
  (import.meta.env.VITE_FFS_ENVIRONMENT as string | undefined)?.trim() ||
  import.meta.env.MODE ||
  'unknown';
export const UI_FEEDBACK_MIN_CHARS = Number(import.meta.env.VITE_FFS_FEEDBACK_MIN_CHARS || 1);
export const UI_FEEDBACK_MAX_CHARS = Number(import.meta.env.VITE_FFS_FEEDBACK_MAX_CHARS || 2000);

export function buildFeedbackExtras(
  principal: CockpitPrincipal | null,
  route: string,
  sessionId: string | null,
): Record<string, unknown> {
  return {
    source: 'techmer-sales-order-automation',
    surface: 'admin-frontend',
    sessionId,
    username: principal?.username,
    displayName: principal?.displayName,
    roles: principal?.roles,
    appVersion: cockpitVersion.compound,
    route,
  };
}
